import type React from 'react';

import classes from '../Chat.module.scss';
import type { ChatRole } from '../types';

interface Props {
  role: ChatRole;
  onQuestionClick: (question: string) => void;
}

const STUDENT_QUESTIONS = [
  'Какая стоимость занятия?',
  'Какая длительность занятия?',
  'Здравствуйте',
  'Когда можно начать?',
];

const TUTOR_QUESTIONS = [
  'Здравствуйте!',
  'Расскажите подробнее о цели занятий',
  'Когда удобно начать?',
  'Есть ли предпочтения по формату?',
];

export const SuggestedQuestions: React.FC<Props> = ({ role, onQuestionClick }) => {
  const questions = role === 'tutor' ? TUTOR_QUESTIONS : STUDENT_QUESTIONS;
  const heading =
    role === 'tutor' ? 'Быстрые сообщения ученику:' : 'Спросите у репетитора:';

  return (
    <div className={classes['suggested-questions']}>
      <h4>{heading}</h4>
      <div className={classes['questions-grid']}>
        {questions.map((question) => (
          <button
            key={question}
            type='button'
            className={classes['question-button']}
            onClick={() => onQuestionClick(question)}
          >
            {question}
          </button>
        ))}
      </div>
    </div>
  );
};
